import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    width: '15rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttonContainer: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  paymentTotal: {
    color: theme.palette.primary.main,
  },
  paymentTotalContainer: {
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
}));

export default useStyles;
